const selector = document.getElementsByClassName('js_unpacking_selector')[0];
const messageElement = document.getElementById('js_unpacking_cost_message');
const classNameToHideMessage = 'hide';

const changeMessageDisplay = () => {
  if (selector.value.match(/あり/) || selector.value.match(/有/)) {
    messageElement.classList.remove(classNameToHideMessage);
  } else {
    messageElement.classList.add(classNameToHideMessage);
  }
};

window.addEventListener('DOMContentLoaded', () => {

if (!messageElement || !selector) {
    return;
}
  changeMessageDisplay();
  selector.addEventListener('change', () => {
    changeMessageDisplay();
  });
});
